<template>
  <div
    v-if="showControls"
    class="controls"
    :class="alignmentClass"
  >
    <sh-button
      v-if="cta1Href"
      class="cta"
      :[btnLinkKeyCTA1]="cta1Href"
      :color="buttonColor"
      :target="cta1Target"
      :aria-label="cta1HiddenText || cta1Title"
      :[setStyleCTA1]=true
    >
      {{ cta1Text }}
    </sh-button>
    <sh-button
      v-if="cta2Href"
      class="cta"
      :[btnLinkKeyCTA2]="cta2Href"
      :color="buttonColor"
      :target="cta2Target"
      :aria-label="cta2HiddenText || cta2Title"
      :[setStyleCTA2]="true"
    >
      {{ cta2Text }}
    </sh-button>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import CTA from '~/constants/appearance'
import ALIGNMENT from '~/constants/alignment'
import { getButtonType } from '~/helpers/get-button-type'
import mapFields from '~/helpers/map-fields'
import getButtonStyle from '~/helpers/get-button-style'

const { mapGetters: mapJssGetters } = createNamespacedHelpers('jss')
const { mapGetters: mapEnvGetters } = createNamespacedHelpers('ui/environment')

export default {
  name: 'EditorialCta',

  props: {
    fields: {
      type: Object,
      default: () => ({})
    },
    desktopAlignment: {
      type: String,
      default: 'Left',
      validator: value => Object.values(ALIGNMENT).includes(value)
    }
  },

  computed: {
    ...mapJssGetters(['isEditMode']),
    ...mapEnvGetters(['isDarkTheme']),
    ...mapFields({
      cta1Href: 'cta1.value.href',
      cta2Href: 'cta2.value.href',
      cta1Appearance: 'cta1Appearance.value',
      cta2Appearance: 'cta2Appearance.value',
      cta1Target: 'cta1.value.target',
      cta2Target: 'cta2.value.target',
      cta1Text: 'cta1.value.text',
      cta2Text: 'cta2.value.text',
      cta1Title: 'cta1.value.title',
      cta2Title: 'cta2.value.title',
      cta1HiddenText: 'cta1.value.data-hidden-text',
      cta2HiddenText: 'cta2.value.data-hidden-text'
    }),

    showControls () {
      return this.isEditMode || this.cta1Href || this.cta2Href
    },

    btnLinkKeyCTA1 () {
      return getButtonType(this.cta1Href)
    },

    btnLinkKeyCTA2 () {
      return getButtonType(this.cta2Href)
    },

    alignmentClass () {
      return `desktop-align-${this.desktopAlignment}`.toLowerCase()
    },

    setStyleCTA1 () {
      return getButtonStyle(this.cta1Appearance)
    },

    setStyleCTA2 () {
      return getButtonStyle(this.cta2Appearance)
    },

    buttonColor () {
      return this.isDarkTheme ? CTA.SECONDARY : CTA.PRIMARY
    }
  }
}
</script>

<style lang="scss" scoped>
.controls {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding-top: $space-060;

  @include tablet {
    flex-direction: row;
  }

  &.desktop-align-center {
    @include tablet {
      justify-content: center;
      align-items: center;
    }
  }

  .cta {
    @include stack-space($space-050);

    @include tablet {
      @include stack-space(0);
      @include inline-space($space-060);
    }
  }
}
</style>
